import { axiosInstance } from '@/lib/utils';
import type {
  ProductCreationPayload,
  ProductModificationPayload,
} from './payload';
import { endpoints } from '@/api';
import type { Product, RequestResponse } from '@/types';

export const createProduct = async (payload: ProductCreationPayload) => {
  const response = await axiosInstance.post<RequestResponse<Product>>(
    endpoints.products,
    payload
  );
  return response.data;
};

export const updateProduct = async ({
  id,
  ...payload
}: ProductModificationPayload) => {
  const response = await axiosInstance.patch<RequestResponse<Product>>(
    `${endpoints.products}/${id}`,
    payload
  );
  return response.data;
};

export const deleteProduct = async (id: number) => {
  const response = await axiosInstance.delete<RequestResponse<Product>>(
    `${endpoints.products}/${id}`
  );
  return response.data;
};
